import { ArrowRight, BookOpen, BookOpenCheck, GitCommit } from "lucide-react";
import { Link } from "react-router";

const learningViews = [
  {
    description:
      "Follow guided lessons built around carefully selected milestone commits.",
    icon: BookOpen,
    label: "Course",
    question: "What should I learn next?",
    to: "/course",
  },
  {
    description:
      "Deepen your understanding with topic-focused explanations and exercises.",
    icon: BookOpenCheck,
    label: "Concepts",
    question: "How does this work?",
    to: "/concepts",
  },
  {
    description:
      "Inspect every commit and browse the complete source at any point in history.",
    icon: GitCommit,
    label: "Repository",
    question: "How did the project evolve?",
    to: "/commits",
  },
] as const;

export function LearningMap() {
  return (
    <section aria-labelledby="learning-map-title" className="grid gap-5">
      <div className="grid max-w-3xl gap-2">
        <h2
          className="text-2xl leading-tight font-semibold"
          id="learning-map-title"
        >
          How this course works
        </h2>
        <p className="text-muted-foreground leading-7">
          Start with the guided Course, then follow Concepts and Repository
          links whenever you want a deeper explanation or the complete source.
        </p>
      </div>

      <nav aria-label="Learning map" className="grid gap-3 md:grid-cols-3">
        {learningViews.map((view) => {
          const Icon = view.icon;

          return (
            <Link
              key={view.label}
              className="bg-card hover:bg-accent/50 group grid min-h-48 content-between gap-5 rounded-md border p-5 shadow-sm transition"
              to={view.to}
            >
              <span className="grid gap-4">
                <span className="bg-secondary text-secondary-foreground ring-border/70 flex size-10 items-center justify-center rounded-md shadow-xs ring-1">
                  <Icon className="size-4" />
                </span>
                <span className="grid gap-1.5">
                  <span className="text-lg font-semibold">{view.label}</span>
                  <span className="text-muted-foreground text-xs font-medium">
                    {view.question}
                  </span>
                </span>
                <span className="text-muted-foreground text-sm leading-6">
                  {view.description}
                </span>
              </span>
              <span className="inline-flex items-center gap-1.5 text-sm font-medium">
                Explore {view.label.toLowerCase()}
                <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" />
              </span>
            </Link>
          );
        })}
      </nav>
    </section>
  );
}
